/* custom-cart-popover.js — keeps the header cart popover (and its count
   badge) in sync after an AJAX add-to-cart, since Horizon's add-to-cart
   flow doesn't reload the page. Listens for Shopify's standard cart-update
   event and re-fetches /cart.js to re-render the item list client-side.
   Also wires up the per-item remove button inside the popover. */
(function () {
  var LIMIT = 4;

  /** @param {string} str */
  function escapeHtml(str) {
    /** @type {Record<string, string>} */
    var entities = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    return String(str).replace(/[&<>"']/g, function (c) {
      return entities[c] || c;
    });
  }

  /**
   * @param {number} cents
   * @param {string} currency
   */
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /**
   * @param {HTMLElement} root
   * @param {any} cart
   */
  function renderPanel(root, cart) {
    var panel = root.querySelector('[data-custom-cart-panel]');
    if (!panel) return;

    if (!cart.item_count) {
      panel.innerHTML = '<p class="custom-header__cart-empty">Your cart is empty.</p>';
      return;
    }

    var items = cart.items
      .slice(0, LIMIT)
      .map(function (item) {
        var src = item.image ? item.image + (item.image.indexOf('?') === -1 ? '?width=88' : '&width=88') : '';
        var img = src
          ? '<img src="' + escapeHtml(src) + '" width="44" height="44" alt="" loading="lazy">'
          : '';
        return (
          '<li>' +
          '<a href="' + escapeHtml(item.url) + '" class="custom-header__cart-item-image">' + img + '</a>' +
          '<div class="custom-header__cart-item-info">' +
          '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
          '<span>' + item.quantity + ' &times; ' + money(item.price, cart.currency) + '</span>' +
          '</div>' +
          '<button type="button" class="custom-header__cart-item-remove" data-cart-remove data-line-key="' +
          escapeHtml(item.key) +
          '" aria-label="Remove ' + escapeHtml(item.product_title) + ' from cart">&times;</button>' +
          '</li>'
        );
      })
      .join('');

    var remaining = cart.item_count - LIMIT;
    var more = remaining > 0
      ? '<p class="custom-header__cart-more">+' + remaining + ' more item' + (remaining > 1 ? 's' : '') + '</p>'
      : '';

    var cartUrl = root.dataset.cartUrl || '/cart';

    panel.innerHTML =
      '<ul class="custom-header__cart-items">' + items + '</ul>' +
      more +
      '<div class="custom-header__cart-footer">' +
      '<span>Subtotal: ' + money(cart.total_price, cart.currency) + '</span>' +
      '<a href="' + escapeHtml(cartUrl) + '" class="custom-header__cart-view">View Cart</a>' +
      '</div>';
  }

  /**
   * @param {HTMLElement} root
   * @param {any} cart
   */
  function updateBadge(root, cart) {
    var link = root.querySelector('.custom-header__cart-link');
    if (link) link.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');

    var bubble = root.querySelector('.cart-bubble');
    if (!bubble) return;
    bubble.classList.toggle('visually-hidden', cart.item_count === 0);

    var count = bubble.querySelector('.cart-bubble__text-count');
    if (!count) return;
    count.classList.toggle('hidden', cart.item_count === 0);
    count.textContent = cart.item_count > 0 && cart.item_count < 99 ? String(cart.item_count) : '';
  }

  /**
   * @param {HTMLElement} root
   * @param {any} cart
   */
  function applyCart(root, cart) {
    renderPanel(root, cart);
    updateBadge(root, cart);
  }

  function refresh() {
    var roots = document.querySelectorAll('[data-custom-cart-popover]');
    if (!roots.length) return;

    fetch('/cart.js', { headers: { accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        roots.forEach(function (root) {
          applyCart(/** @type {HTMLElement} */ (root), cart);
        });
      })
      .catch(function () {});
  }

  /** @param {string} lineKey */
  function removeLine(lineKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    }).then(function (res) {
      return res.json();
    });
  }

  /**
   * @param {HTMLElement} li
   * @returns {Promise<void>}
   */
  function playRemoveAnimation(li) {
    return new Promise(function (resolve) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        li.removeEventListener('transitionend', finish);
        resolve();
      }
      li.addEventListener('transitionend', finish);
      setTimeout(finish, 300);
      li.classList.add('is-removing');
    });
  }

  document.addEventListener('shopify:cart:lines-update', refresh);

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!(target instanceof Element)) return;

    var trigger = target.closest('[data-cart-remove]');
    if (!trigger) return;
    e.preventDefault();

    var btn = /** @type {HTMLButtonElement} */ (trigger);
    var rootEl = /** @type {HTMLElement | null} */ (btn.closest('[data-custom-cart-popover]'));
    var lineKey = btn.getAttribute('data-line-key');
    var li = btn.closest('li');
    if (!rootEl || !lineKey) return;

    var root = rootEl;
    btn.disabled = true;

    var animation = li ? playRemoveAnimation(li) : Promise.resolve();

    Promise.all([animation, removeLine(lineKey)])
      .then(function (results) {
        applyCart(root, results[1]);
      })
      .catch(function () {
        btn.disabled = false;
        if (li) li.classList.remove('is-removing');
      });
  });
})();
